<template>
  <div>
    <p v-if="guest.lead_guest" class="text-sm font-semibold">{{ $t("Lead guest") }}:</p>
    <p v-else class="text-sm font-semibold">{{ $t("Guest") }}:</p>
    <span v-if="!!guest.first_name" class="text-md flex">Name: {{ guest.first_name }} {{ guest.last_name }}</span>
    <p v-if="!!guest?.gender">{{ $t("Gender") }}: {{ guest?.gender }}</p>
    <p v-if="!!guest?.date_of_birth">{{ $t("Date of birth") }}: {{ guest?.date_of_birth }}</p>
    <p v-if="!!guest?.contact_email">{{ $t("Email") }}: {{ guest?.contact_email }}</p>
    <p v-if="!!guest?.passport_number">{{ $t("Passport number") }}: {{ guest?.passport_number }}</p>
  </div>
</template>

<script setup>
const { guest } = defineProps({
  guest: { required: true },
});
</script>
